import React from 'react';
import { QuestionForm } from '@catalogo/ui-americanas-desktop-product-form/src/components/organisms/QuestionForm';
import { Wrapper, Message, List, ButtonDeskUI } from './styled';
import { TermNotFoundProps } from '../../../types';

export const TermNotFound = React.memo((props: TermNotFoundProps) => {
  const { productId, dispatchMetrics, product, config, isDesk } = props;

  const formButton = isDesk ? (
    <ButtonDeskUI
      href={`/perguntar/${productId}`}
      width="198px"
      height="52px"
      title="Fazer pergunta"
      borderRadius="8px"
      fontSize="16px"
    />
  ) : (
    <QuestionForm
      className="text2"
      productId={productId}
      config={config}
      product={product}
      dispatchMetrics={dispatchMetrics}
      metricParams={{
        category: 'qna-pdp',
        action: 'fazer-pergunta',
        label: 'busca-sem-resultado',
      }}
    >
      Fazer pergunta
    </QuestionForm>
  );

  return (
    <Wrapper isDesk={isDesk}>
      <Message isDesk={isDesk}>O que você pode fazer?</Message>
      <List isDesk={isDesk}>
        <li>Ver se o termo digitado tá certinho e tentar pesquisar de novo ou</li>
        <li>Fazer uma pergunta pra gente ;)</li>
      </List>
      {formButton}
    </Wrapper>
  );
});

export default TermNotFound;
